import {AccountInfo} from "../../util/interfaces";

export enum AccountActions {
  SUCCESS_GET_ACCOUNT = '@@app/SUCCESS_GET_ACCOUNT',
  FAILED_GET_ACCOUNT = '@@app/FAILED_GET_ACCOUNT',
  SUCCESS_ADD_SHOPIFY_ATTRIBUTES = '@@app/SUCCESS_ADD_SHOPIFY_ATTRIBUTES',
  FAILED_ADD_SHOPIFY_ATTRIBUTES = '@@app/FAILED_ADD_SHOPIFY_ATTRIBUTES',
  CLEAR_ACCOUNT_ERROR = '@@app/CLEAR_ACCOUNT_ERROR'
}

interface SuccessGetAccount {
  type: typeof AccountActions.SUCCESS_GET_ACCOUNT,
  payload: AccountInfo
}

interface FailedGetAccount {
  type: typeof AccountActions.FAILED_GET_ACCOUNT,
  payload: string
}

interface SuccessAddShopifyAttributes {
  type: typeof AccountActions.SUCCESS_ADD_SHOPIFY_ATTRIBUTES,
  payload: string
}

interface FailedAddShopifyAttributes {
  type: typeof AccountActions.FAILED_ADD_SHOPIFY_ATTRIBUTES,
  payload: string
}

interface ClearAccountError {
  type: typeof AccountActions.CLEAR_ACCOUNT_ERROR
}


export type AccountActionType =
  SuccessGetAccount |
  FailedGetAccount |
  SuccessAddShopifyAttributes |
  FailedAddShopifyAttributes |
  ClearAccountError;

